import React, { useEffect, useState } from "react";
import { Empty } from 'antd';
import DigitalKobiListComponent from './DigitalKobiListComponent'
import RequestHandler from "../../../../util/RequestHandler";

const DigitalKobiPage = (props) => {
    const [list, setList] = useState([])
    const [dataState, setDataState] = useState([{ skip: 0, take: 5 }]);
    const [take, setTake] = useState(5);
    const [skip, setSkip] = useState(0);
    const [activeKey, setActiveKey] = useState('');
    const [query, setQuery] = useState('');
    useEffect(() => {
        RequestHandler.get(`/${props.IsEInvoice?'Einvoice':'Earchive'}?LastFive=true`).then(response => {
            setList(response.value);
        });
    }, [query, setDataState, skip, setSkip, setActiveKey]);

    const ContactSideBar = (value) => {
        return <DigitalKobiListComponent data={list} isDigitHomePage={props.isDigitHomePage} IsEInvoice = {props.IsEInvoice} />
    };
    return (
        <div>
            {
                list.length === 0 ? <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" /> :
                    ContactSideBar()
            }
        </div>
    )
}

export default DigitalKobiPage
